#import "../fragments/peep-related-lead-cards-fragment.graphql"

query GetPeepRelatedLeadCards($id: ID!) {
    peep(id: $id) {
        ...PeepRelatedLeadCards
    }
}
